<template>
  <div class="scrollbar">
    <loader :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader" ></loader>
    <message :message="response_msg" :messageType="msg_type" v-if="response_msg != ''" ></message>
    <div class="col-12 inMiddle-area mt-2" v-if="  parseInt(get_user.verified_status) == 1 &&  affiliateCommList.outstanding > 0">
      <div v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && authComponent && transaction_id != '' && !congModuleWithdrawal">
        <appTwofa :call_from="request_page"></appTwofa>
      </div>
      <div class="row justify-content-center" v-else>
        <div class="col-12 col-md-6">
          <div class="withdrawalNewl whiteBG box-shadow">
            <div class="outtAmount row" v-if="transaction_id == '' && !congModuleWithdrawal">
              <div class="col-12 stepForm">
                <div class="card custom-card noneBoxShadow gradientThemecolor mb-3">
                  <div class="card-body">
                    <div class="card-item">
                      <div class="card-item-body d-flex align-items-center justify-content-between">
                        <div class="card-item-stat">
                          <div class="thisMonth">
                            <label class="main-content-label tx-13 font-weight-bold mb-0">Outstanding amount</label>
                          </div>
                        </div>
                        <h4 class="font-weight-bold green" v-html="affiliateCommList.outstanding != undefined &&  affiliateCommList.outstanding != '' &&  affiliateCommList.outstanding != null ? '$' + Math.round((affiliateCommList.outstanding + Number.EPSILON) *100)/100 : '$0'"></h4>
                        <div class="card-icon-img">
                          <img src="../../../../static/fxView/images/outstanding.svg" alt="Icon" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <h4 class="mb-3">Select Withdrawal Method</h4>
                <div class="form-group field-wrapper mb-3">
                  <ul class="twoColumn d-flex align-items-center flex-wrap depositpaymentMethod withdrawal w-100">
                    <!-- <li class="mb-2 mr-2">
                      <label class="customRadio-button">
                        <div class="lft d-flex align-items-center">
                          <img src="../../../../static/fxView/images/bank_transfer.svg" alt="Bank Account" class="mr-2" />
                        </div>
                        <div class="rft">
                          <input type="radio" name="radio" v-model="method" value="bank" aria-required="true" aria-invalid="false" v-validate="{ required: true }" />
                          <span class="checkmark"></span>
                        </div>
                      </label>
                    </li> -->
                    <li class="mb-2 mr-2">
                      <label class="customRadio-button">
                        <div class="lft d-flex align-items-center">
                          Trading Account/Wallet
                        </div>
                        <div class="rft">
                          <input type="radio" name="radio" v-model="method" value="trading_or_wallet" aria-required="true" aria-invalid="false" v-validate="{ required: true }" />
                          <span class="checkmark"></span>
                        </div>
                      </label>
                    </li>
                    <li class="mb-2 mr-2" >
                      <label class="customRadio-button">
                        <div class="lft d-flex align-items-center">
                          Skrill
                        </div>
                        <div class="rft">
                          <input type="radio" name="radio" v-model="method" value="skrill" aria-required="true" @click="getSavedList('2',getUserProfile.banks)" aria-invalid="false" v-validate="{ required: true }" />
                          <span class="checkmark"></span>
                        </div>
                      </label>
                    </li>
                    <li class="mb-2 mr-2" >
                      <label class="customRadio-button">
                        <div class="lft d-flex align-items-center">
                          Neteller
                        </div>
                        <div class="rft">
                          <input type="radio" name="radio" v-model="method" value="neteller" aria-required="true" @click="getSavedList('3',getUserProfile.banks)" aria-invalid="false" v-validate="{ required: true }" />
                          <span class="checkmark"></span>
                        </div>
                      </label>
                    </li>
                    <li class="mb-2 mr-2" >
                      <label class="customRadio-button">
                        <div class="lft d-flex align-items-center">
                          Crypto
                        </div>
                        <div class="rft">
                          <input type="radio" name="radio" v-model="method" value="crypto" aria-required="true" @click="getSavedList('4',getUserProfile.banks)" aria-invalid="false" v-validate="{ required: true }" />
                          <span class="checkmark"></span>
                        </div>
                      </label>
                    </li>
                  </ul>
                  <p class="error" v-if="submitted && errors.first('radio')">
                    The payment method is required
                  </p>
                </div>
                <!-- Skrill -->
                <div v-if="method == 'skrill'">
                  <!-- <label class="list-group-item bankcard head" v-if="withdrawalSkrillList && withdrawalSkrillList!=''">
                    <div class="d-flex justify-content-between align-items-center">
                      <template v-for="list in withdrawalSkrillList">
                        <div class="d-flex" v-if="list.skrill_address_id !=''">
                          <h4 class="pl-3" v-if="list.skrill_address_id !=''">
                            <span>{{ list.skrill_address_id }}&nbsp;</span>
                          </h4>
                          <div class="rft" v-if="list.skrill_address_id !=''">
                            <input type="radio" id="one" :value="list.skrill_address_id" v-model="skrill_id" @click="transaction_Update_id = list.transaction_id" v-validate="{ required: true }" name="Skrill id" />
                          </div>
                        </div>
                      </template>
                    </div>
                  </label>
                  <div class="form-group field-wrapper" v-else>
                    <input type="text" class="float-field form-control" placeholder="Please provide Skrill Id.."  v-model="skrill_id" name="Skrill id" v-validate="{ required: true }">
                    <p class="error" v-if="submitted" v-for="error in errors.collect('Skrill id')">
                      {{ error }}
                    </p>
                  </div> -->
                  <div class="mb-3" v-if="skrill_id == ''">
                    <p> 
                      you don't have any Skrill ID , please
                      <router-link :to="{name: 'fxView.support',params: {  tabName: 'requestServiceElement',  ticketData: '16',  method_id: '2',  page: 'withdrawal',}, }">
                        {{ $t("dep_acc_fund_clkHere") }}
                      </router-link>
                      to create new ID
                    </p>
                  </div>
                  <template v-else>
                    <label class="main-content-label tx-13 font-weight-bold mb-2" >Specify the Withdrawal amount</label>
                    <div class="form-group field-wrapper">
                      <div class="position-relative">
                        <input placeholder=" " v-model="reqamount" @input="handleInput" type="number" name="amount" class="float-field form-control" aria-required="true" aria-invalid="true" v-validate="'required|min_value:0.001|decimal:3'" />
                        <label for="amount" class="float-label">Amount</label>
                      </div>
                      <p class="error" v-if="submitted && reqamount == ''" v-for="error in errors.collect('amount')">
                        {{ error }}
                      </p>
                      <p v-if="submitted && !(parseFloat(affiliateCommList.outstanding) >= parseFloat(reqamount)) && parseFloat(reqamount) > 0 " class="text-danger">
                        Insufficient amount balance to withdrawal
                      </p>
                      <p v-if="submitted && parseFloat(reqamount) <= 0" class="text-danger">
                        Insert valid Amount
                      </p>
                    </div>
                    
                    <div class="clearfix"></div>
                    <div>
                      <div class="submitButton d-flex justify-content-end align-items-center w-100 mt-2 text-center">
                        <button type="button" class="common_btn" @click.stop="requestwithdraw()">
                          Proceed To Withdrawal
                        </button>
                      </div>
                    </div>
                  </template>
                </div>
                <!-- Neteller -->
                <div v-if="method == 'neteller'">
                  <!-- <label class="list-group-item bankcard head" v-if="withdrawalNetellerList && withdrawalNetellerList!=''">
                    <div class="d-flex justify-content-between align-items-center">
                      <template v-for="list in withdrawalNetellerList">
                        <div class="d-flex" v-if="list.neteller_address_id !=''">
                          <h4 class="pl-3" >
                            <span>{{ list.neteller_address_id }}&nbsp;</span>
                          </h4>
                          <div class="rft">
                            <input type="radio" id="one" :value="list.neteller_address_id" @click="transaction_Update_id = list.transaction_id" v-model="neteller_id" v-validate="{ required: true }" name="Neteller id" />
                          </div>
                        </div>
                      </template>
                    </div>
                  </label>
                  <div class="form-group field-wrapper" v-else>
                    <input type="text" class="float-field form-control" placeholder="Please provide Neteller Id.."  v-model="neteller_id" name="Neteller id" v-validate="{ required: true }">
                    <p class="error" v-if="submitted" v-for="error in errors.collect('Neteller id')">
                      {{ error }}
                    </p>
                  </div> -->
                  <div class="mb-3" v-if="neteller_id == ''">
                    <p>
                      you don't have any Neteller ID , please
                      <router-link :to="{name: 'fxView.support',params: {  tabName: 'requestServiceElement',  ticketData: '16',  method_id: '3',  page: 'withdrawal'}}">
                        {{ $t("dep_acc_fund_clkHere") }}
                      </router-link>
                      to create new ID
                    </p>
                  </div>
                  <template v-else>
                    <label class="main-content-label tx-13 font-weight-bold mb-2" >Specify the Withdrawal amount</label>
                    <div class="form-group field-wrapper">
                      <div class="position-relative">
                        <input placeholder="" v-model="reqamount" @input="handleInput" type="number" name="amount" class="float-field form-control" aria-required="true" aria-invalid="true" v-validate="'required|min_value:0.001|decimal:3'" />
                        <label for="amount" class="float-label">Amount</label>
                      </div>
                      <p class="error" v-if="submitted" v-for="error in errors.collect('amount')">
                        {{ error }}
                      </p>
                      <p v-if="submitted && !(parseFloat(affiliateCommList.outstanding) >= parseFloat(reqamount)) && parseFloat(reqamount) > 0 " class="text-danger">
                        Insufficient amount balance to withdrawal
                      </p>
                      <p v-if="submitted && parseFloat(reqamount) <= 0" class="text-danger">
                        Insert valid Amount
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <div>
                      <div class="submitButton d-flex justify-content-end align-items-center w-100 mt-2 text-center">
                        <button type="button" class="common_btn" @click.stop="requestwithdraw()">
                          Proceed To Withdrawal
                        </button>
                      </div>
                    </div>
                  </template>    
                     
                </div>
                <!--Crypto-->
                <div v-if="method == 'crypto'">
                  <template v-if="crypto_id_list != ''">
                    <!-- <label class="list-group-item bankcard head" > -->
                      <div class="d-flex justify-content-between align-items-center mb-2" >
                        <!-- <div class="form-group field-wrapper" > -->
                          <select class="float-field form-control" v-model="crypto_id" name="Select Crypto" v-validate="{ required: true }">
                            <option value="" selected="" disabled>
                              Please select Crypto Address
                            </option>
                            <option v-for="list in crypto_id_list" :value="list" v-if="list && (list.online_payment_id != '' || list.online_payment_id != null || list.online_payment_id != undefined || list.online_payment_id != '0')">
                              {{  list.online_payment_id }}
                            </option>
                          </select>  
                        <!-- </div>   -->
                      </div>
                      <div class="d-flex justify-content-between align-items-center" >
                        <p class="error" v-if="submitted" v-for="error in errors.collect('Select Crypto')">
                          {{ error }}
                        </p> 
                      </div>
                     
                    <!-- </label> -->
                    <label class="main-content-label tx-13 font-weight-bold mb-2" >Specify the Withdrawal amount</label>
                    <div class="form-group field-wrapper">
                      <div class="position-relative">
                        <input v-model="reqamount" @input="handleInput" type="number" name="amount" class="float-field form-control" aria-required="true" aria-invalid="true" 
                        v-validate="'required|min_value:0.001|decimal:3'" />
                        <label for="amount" class="float-label">Amount</label>
                      </div>
                      <p class="error" v-if="submitted" v-for="error in errors.collect('amount')">
                        {{ error }}
                      </p>
                      <p v-if="submitted && !(parseFloat(affiliateCommList.outstanding) >= parseFloat(reqamount)) && parseFloat(reqamount) > 0 " class="text-danger">
                        Insufficient amount balance to withdrawal
                      </p>
                      <p v-if="submitted && parseFloat(reqamount) <= 0" class="text-danger">
                        Insert valid Amount
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <div>
                      <div class="submitButton d-flex justify-content-end align-items-center w-100 mt-2 text-center">
                        <button type="button" class="common_btn" @click.stop="requestwithdraw()">
                          Proceed To Withdrawal
                        </button>
                      </div>
                    </div>
                  </template>
                  <div class="mb-3" v-if="(crypto_id_list && crypto_id_list == '') || crypto_id_list.length < 3">
                    <div class="clearfix"></div>
                    <p>
                      If don't have any cryptocurrency address linked. Please
                      <router-link :to="{name: 'fxView.support',params: {tabName: 'requestServiceElement', ticketData: '16', method_id: '4', page: 'withdrawal'}}">
                        {{ $t("dep_acc_fund_clkHere") }}
                      </router-link>
                      to add a new cryptocurrency address.
                    </p>
                  </div>
                </div>
                <div v-if="method == 'trading_or_wallet'">
                  <div v-if="ibtradingList.length > 0">
                    <div class="form-group field-wrapper" v-if="method == 'trading_or_wallet'">
                      <select class="float-field form-control" v-model="trading_id" name="trading id" v-if="ibtradingList.length > 0" v-validate="{ required: true }">
                        <option value="" selected="">
                          Please select Trading account
                        </option>
                        <option v-for="(value, key) in ibtradingList" :value="value.wallet_no" v-if="value.wallet_no != '' && value.wallet_no != null && value.wallet_no != undefined">
                          {{  value.wallet_no }}
                        </option>
                        <option v-for="(value, key) in ibtradingList" :value="value.account_id" v-else>
                          {{ value.account_id }}
                        </option>
                      </select>
                      <p class="error" v-if="submitted" v-for="error in errors.collect('trading id')">
                        {{ error }}
                      </p>
                    </div>

                    <label class="main-content-label tx-13 font-weight-bold mb-2" >Specify the Withdrawal amount</label>
                    <div class="form-group field-wrapper">
                      <div class="position-relative">
                        <input placeholder=" " v-model="reqamount" @input="handleInput" type="number" name="amount" class="float-field form-control" aria-required="true" aria-invalid="true" v-validate="'required|min_value:0.001|decimal:3'" />
                        <label for="amount" class="float-label">Amount</label>
                      </div>
                      <p class="error" v-if="submitted" v-for="error in errors.collect('amount')">
                        {{ error }}
                      </p>
                      <p v-if="submitted && !(parseFloat(affiliateCommList.outstanding) >= parseFloat(reqamount)) && parseFloat(reqamount) > 0 " class="text-danger">
                        Insufficient amount balance to withdrawal
                      </p>
                      <p v-if="submitted && parseFloat(reqamount) <= 0" class="text-danger">
                        Insert valid Amount
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <div>
                      <div class="submitButton d-flex justify-content-end align-items-center w-100 mt-2 text-center">
                        <button type="button" class="common_btn" @click.stop="requestwithdraw()">
                          Proceed To Withdrawal
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3" v-else>
                    <p>
                      you don't have any trading account or wallet, please
                      <router-link :to="{  name: 'fxView.support',  params: {tabName: 'requestServiceElement', ticketData: '171', method_id: '173', page: 'withdrawal'},}">
                        {{ $t("dep_acc_fund_clkHere") }}
                      </router-link>
                      to link account.
                    </p>
                  </div>
                </div>
                <div v-if="method == 'bank'">
                  <div v-if="getUserProfile.banks.length > 0">
                    <div v-for="(list, index) in getUserProfile.banks">
                      <label class="list-group-item bankcard head" v-if="list.method == '1'">
                        <div class="d-flex justify-content-between align-items-center">
                          <div class="d-flex">
                            <h4 class="pl-3">
                              <span >{{ list.account_no }}&nbsp;</span>
                            </h4>
                            <div class="rft">
                              <input type="radio" id="one" :value="list" v-model="bankData" v-validate="{ required: true }" name="bankData" :class="{   'is-invalid':     submitted && errors.has('bankData'), }" ref="bankDataInput"/>
                              <!-- <div class="checkmark"></div> -->
                            </div>
                          </div>
                          <div>
                            <a href="#" class="green" @click="detailDiv(index)" v-if="index == showIndex" >{{ $t("dep_acc_fund_lessDet") }}</a>
                            <a href="#" class="green" @click="detailDiv(index)" v-else >{{ $t("dep_acc_fund_viewDet") }}</a>
                          </div>
                        </div>
                      </label>
                      <div class="personalForm list-group mb-3" :ref="'buttons' + index" v-if="index == showIndex">
                        <div class="list-group-item d-flex justify-content-between align-items-center">
                          <span class="titleArea">{{ $t("dep_holderName") }}</span>
                          <span>{{ list.holder_name }}</span>
                        </div>
                        <div class="list-group-item d-flex justify-content-between align-items-center">
                          <span class="titleArea">{{ $t("prof_bankName") }}</span>
                          <span>{{ list.bank_name }}</span>
                        </div>
                        <div class="list-group-item d-flex justify-content-between align-items-center">
                          <span class="titleArea">{{ $t("prof_bankAdd") }}</span>
                          <span>{{ list.bank_address }}</span>
                        </div>
                        <div class="list-group-item d-flex justify-content-between align-items-center">
                          <span class="titleArea">{{ $t("dep_sortCode") }}</span>
                          <span>{{ list.sort_code }}</span>
                        </div>
                      </div>
                    </div>
                    <ul v-if="submitted && bankData == ''">
                      <li class="error">Please Select Account</li>
                    </ul>
                    <label class="main-content-label tx-13 font-weight-bold mb-2">Specify the Withdrawal amount</label>
                    <div class="form-group field-wrapper">
                      <div class="position-relative">
                        <input placeholder=" " v-model="reqamount" @input="handleInput" type="number" name="amount" class="float-field form-control" aria-required="true" aria-invalid="true" v-validate="'required|min_value:0.001|decimal:3'" />
                        <label for="amount" class="float-label">Amount</label>
                      </div>
                      <p class="error" v-if="submitted" v-for="error in errors.collect('amount')">
                        {{ error }}
                      </p>
                      <p v-if="submitted &&!(  parseFloat(affiliateCommList.outstanding) >=  parseFloat(reqamount)) &&parseFloat(reqamount) > 0" class="text-danger">
                        Insufficient amount balance to withdrawal
                      </p>
                      <p v-if="submitted && parseFloat(reqamount) <= 0" class="text-danger">
                        Insert valid Amount
                      </p>
                    </div>
                    <div class="clearfix"></div>
                    <div>
                      <div class="submitButton d-flex justify-content-end align-items-center w-100 mt-2 text-center">
                        <button type="button" class="common_btn" @click.stop="requestwithdraw()">
                          Proceed To Withdrawal
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="mb-3" v-else>
                    <p>
                      {{ $t("dep_acc_fund_DontbankAcc") }}
                      <router-link
                        :to="{
                          name: 'fxView.support',
                          params: {
                            tabName: 'requestServiceElement',
                            ticketData: '16',
                            method_id: '1',
                            page: 'withdrawal',
                          },
                        }"
                      >
                        {{ $t("dep_acc_fund_clkHere") }}
                      </router-link>
                      {{ $t("dep_Createbank") }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <!------------------------------------------------------------->
            <div class="partcipate-fund" v-if="transaction_id != '' && !congModuleWithdrawal">
              <div v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 1">
                <p class="mb-3 text-center">
                  {{ $t("rb_googleAuth1") }}
                  <strong>{{ $t("rb_googleAuth2") }}</strong>
                  {{ $t("rb_googleAuth3") }}.
                </p>
                <div class="form-group field-wrapper">
                  <input
                    type="text"
                    placeholder="000 000"
                    class="mdb-select md-form form-control"
                    v-model="otp"
                    v-validate="{ required: true, max: 6, numeric: true }"
                    name="otp"
                    :class="{
                      'is-invalid': submittedCheckOtp && errors.has('otp'),
                    }"
                    ref="otpInput"
                    @keyup.enter="submitCheckOtp()"
                  />
                  <ul>
                    <li v-for="error in errors.collect('otp')">{{ error }}</li>
                  </ul>
                </div>
                <div class="form-group text-center field-wrapper">
                  <button
                    class="prism_btn btn_sm"
                    v-on:click="submitCheckOtp()"
                  >
                    {{ $t("rb_validate") }}
                  </button>
                </div>
                <div class="clearfix"></div>
                <div
                  class="d-flex align-items-center justify-content-between border-top pt-3 mt-3"
                >
                  <div class="desc text-center">
                    <p>
                      {{ $t("rb_googleAuth4") }}
                      <a v-on:click="resendLink()" href="#"
                        ><strong>{{ $t("rb_googleAuth5") }}</strong></a
                      >
                    </p>
                  </div>
                </div>
                <div class="clearfix"></div>
              </div>

              <div class="middleBox1" v-if="parseInt(get_user.profile.gAuthenticatorEnabled) == 0 && !authComponent ">
                <div class="congratulations">
                  <div class="logo_congrats">
                    <img
                      src="../../../../static/fxView/images/withdraw.svg"
                      alt="Icon"
                    />
                  </div>
                  <div class="subtitle">
                    <p class="mb-3">
                      {{ $t("verf_dear") }}
                      <strong class="green">{{ get_user.username }} !</strong>
                      {{ $t("VpsSub_withdrawalAuthMessage") }}
                      <strong>{{ get_user.email }} . </strong>
                    </p>
                    <a v-on:click="resendLink()" href="#" class="mb-3"
                      ><strong>{{ $t("rb_googleAuth7") }}</strong></a
                    >
                  </div>
                </div>
                <!-- <div class="clearfix"></div>
                <div class="d-flex align-items-center justify-content-between enble2fa border-top pt-3 mt-3">
                  <div class="ico mr-3">
                    <img
                      src="../../../../static/fxView/images/google_auth.png"
                      alt="2fa"
                    />
                  </div>
                  <div class="desc w-75">
                    <h5 class="mb-2">
                      <strong>{{ $t("rb_googleAuth8") }}</strong>
                    </h5>
                    <p>
                      {{ $t("rb_googleAuth9") }}
                      <a v-on:click="authComponent = true" href="#"
                        ><strong>{{ $t("rb_googleAuth10") }}</strong></a
                      >
                    </p>
                  </div>
                </div> -->
              </div>
            </div>
            <!------------congo msz final for withdrawal page------------------------->
            <div class="stepForm" v-if="congModuleWithdrawal">
              <div class="congratulations">
                <div class="logo_congrats">
                  <img
                    src="../../../../static/fxView/images/check.svg"
                    alt="Icon"
                  />
                </div>
                <div class="subtitle">
                  <h3>
                    {{ $t("rb_congo") }}
                    <span class="green">{{ get_user.username }}</span>
                  </h3>
                  <p>{{ $t("wit_withdrawalMsz2") }}</p>
                </div>
                <div
                  class="signupbtn full-width submitButton w-100 mt-4 text-center"
                >
                  <a
                    href="#"
                    class="prism_btn btn_sm"
                    @click.prevent="back()"
                    >{{ $t("withdraw_backWithdraw") }}</a
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <no-trading-account
        :totalRecords="affiliateCommList.outstanding"
        :demo_live_both="'to_check_withdrawal_amount'"
      ></no-trading-account>
    </div>
  </div>
</template>
<script>
import { fxViewMixins } from "@/plugins/fxView";
import twoFa from "../users/2FA";
export default {
  name: "WITHDRAWAL",
  mixins: [fxViewMixins],
  data() {
    return {
      skrillAccList:[],
      netellerAccList:[],
      cryptoacclist:[],
      transaction_Update_id:'',
      crypto_id:'',
      crypto_id_list:'',
      crypto_new_id:'',
      skrill_id:"",
      neteller_id: "",
      pageTitle: this.$options.name,
      pageLoader: false,
      response_msg: "",
      msg_type: "",
      submitted: false,
      authComponent: false,
      reqamount: 0,
      trading_id: "",
      method: "trading_or_wallet",
      showIndex: "-1",
      bankData: "",
      otp: "",
      transaction_id: "",
      submittedCheckOtp: false,
      congModuleWithdrawal: false,
      request_page: "withdrawal",
    };
  },
  computed: {
    AllowUser(){
      return [573,1172,343,14].includes(this.get_user.id);
    }
  },
  components: {
    appTwofa: twoFa,
  },
  methods: {
  handleInput(event){
    if(event.target.value < 0) {
      this.reqamount = 0;
    }
  },
    getSavedList(value,data){
      if(value =='2'){
        this.skrillAccList= data.filter(res=> res.method == value)
        if(this.skrillAccList[0] && this.skrillAccList[0].online_payment_id){
          this.skrill_id= this.skrillAccList[0].online_payment_id
          this.skrillAccList=[]
          return this.skrill_id;
        }else{
          return;
        }
        
      }
      if(value =='3'){
        this.netellerAccList= data.filter(res=> res.method == value)
        if(this.netellerAccList[0] && this.netellerAccList[0].online_payment_id){
          this.neteller_id= this.netellerAccList[0].online_payment_id
          this.netellerAccList=[]
          return this.neteller_id;
        }else{
          return;
        }
       
      }
      if(value =='4'){
        this.cryptoacclist= data.filter(res=> res.method == value)
        if(this.cryptoacclist && this.cryptoacclist !=''){
          this.crypto_id_list= this.cryptoacclist
          return this.crypto_id_list;
        }else{
          return;
        }
      }
      // let inputJson = {
      //   globalParams: {
      //     type: value
      //   },
      //   localParams: { parameter: this },
      // };
      // this._runGetWithdrawalMethodlist(inputJson);
      // https://dev.finvasia.com:7702/get/withdrawal/payments
    },
    resendLink() {
      let input_json = {
        globalParams: {
          // trans_id: this.transaction_Update_id,
          trans_id: this.transaction_id.toString(),
        },
        localParams: { parameter: this },
      };
      this._runResendEmailLink(input_json);
    },

    requestwithdraw() {
      this.amount_msg = "";
      const _that = this;
      _that.submitted = true;
      _that.$validator.validate().then((valid) => {
        //console.log(_that.reqamount,"<<<>>>",_that.affiliateCommList.outstanding)
        if ( valid && parseFloat(_that.reqamount) <=   parseFloat(_that.affiliateCommList.outstanding)) {
          let bank_id = "",
            trading_id = "",
            type = 0,walletId = "";
          if (_that.method == "bank") {
            type = 1;
            bank_id = _that.bankData.id;
            trading_id = "";
          } 
          else if (_that.method == "skrill") {
            type = 2;
            bank_id = "";
            trading_id = "";
          }
          else if (_that.method == "neteller") {
            type = 3;
            bank_id = "";
            trading_id = "";
          }
          else if (_that.method == "crypto") {
            type = 4;
            bank_id = "";
            trading_id = "";
          }
          else {
            type = 0;
            bank_id = "";
            trading_id = _that.trading_id;
          }
          let input_json = {
            globalParams: {
              type: type,
              reqamount: _that.reqamount,
              currency: "",

              trading_id: trading_id,
              bank_id: bank_id,
            },
            localParams: { parameter: _that },
          };
          if(_that.method == "trading_or_wallet"){
            if(_that.ibtradingList.length > 0){
              walletId = _that.ibtradingList.filter(val => val.wallet_no == _that.trading_id)[0]
            }
            if(walletId && walletId.wallet_no){
              input_json.globalParams.trading_id = walletId.account_id
              input_json.globalParams.wallet_no = _that.trading_id
            }
          }
          if(_that.method == "bank"){
            input_json.globalParams.bank_account = parseInt(_that.bankData.account_no)
            input_json.globalParams.bank_name = _that.bankData.bank_name
            _that.bankData.bank_name = ''
            _that.bankData.account_no = ''
          }
          if(_that.method == "skrill"){
            input_json.globalParams.skrill_id = _that.skrill_id
            _that.skrill_id = ''
            input_json.globalParams.trading_id= _that.transaction_Update_id
          }
          if(_that.method == "neteller"){
            input_json.globalParams.neteller_id = _that.neteller_id
            _that.neteller_id = ''
            input_json.globalParams.trading_id= _that.transaction_Update_id
          }
          if(_that.method == "crypto"){
            // _that.transaction_Update_id=_that.crypto_id.transaction_id
            input_json.globalParams.crypto_id = _that.crypto_id.online_payment_id
            // input_json.globalParams.crypto_updated_id = _that.crypto_id.id
            input_json.globalParams.trading_id= _that.transaction_Update_id
            _that.crypto_id = ''
          }
          _that._runWithdrawalRequestOtp(input_json);
          return _that.submitted= false;
        } else {
          _that.handleValidationErrorAdvanced(_that.errors);
        }
      });
    },
    submitCheckOtp() {
      const _that = this;
      _that.submittedCheckOtp = true;
      _that.$validator.validate().then((valid) => {
        if (valid) {
          let input_json = {
            globalParams: {
              google_token: _that.otp.toString(),
              trans_id: _that.transaction_id.toString(),
              // trans_id: _that.transaction_Update_id,
            },
            localParams: { parameter: _that },
          };
          _that._runWithdrawalCheckOtp(input_json);
        } else {
          _that.handleValidationErrorAdvanced(_that.errors);
        }
      });
    },
    clear() {
      this.reqamount = "";
      this.trading_id = "";
      this.transaction_Update_id='';
      //this.submitted = true
      this.show_tab = 1;
    },
    detailDiv(index) {
      if (this.showIndex == index) {
        this.showIndex = "-1";
      } else {
        this.showIndex = index;
      }
    },
    request() {
      const _that = this;
      _that.submitted = true;
      _that.$validator.validate().then((valid) => {
        if (valid) {
        } else {
          _that.handleValidationErrorAdvanced(_that.errors);
        }
      });
    },
    listing() {
      let inputJson = {
        globalParams: {
          filter: {},
          sort: [],
          search: this.search,
          page: this.page,
          perPage: this.pageLimit,
        },
        localParams: { parameter: this },
      };
      this._runGetAffiliateEarning(inputJson);
      this._runGetTradingList(inputJson);
      this._runGetIBTradingList(inputJson);
      this._runGetUserProfile({
        globalParams: {},
        localParams: { parameter: this },
      });
      // this._runGetWithdrawalMethodlist({
      //   globalParams: {},
      //   localParams: { parameter: this },
      // });
    },
  },
  created() {
    this.listing();
    this.setData(this.pageTitle);
  },
};
</script>



// WEBPACK FOOTER //
// src/components/fxView/withdrawal/withdrawal.vue